import { AngleUtils } from '../../utils/AngleUtils/AngleUtils';
import { NumberUtils } from '../../utils/NumberUtils/NumberUtils';
export class LocationUtils {
  private constructor() {}

  /**
   * returns the distance in meters rounded to 2 decimals
   */
  public static distanceBetweenCoordinates(latlong1: LatLong, latlong2: LatLong): number {
    const earthRadius = 6371000;
    const dLat = AngleUtils.degToRad(latlong2.latitude - latlong1.latitude);
    const dLon = AngleUtils.degToRad(latlong2.longitude - latlong1.longitude);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(AngleUtils.degToRad(latlong1.latitude)) * Math.cos(AngleUtils.degToRad(latlong2.latitude)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return NumberUtils.round(earthRadius * c, 2); // distance in m
  }
}
export type LatLong = {
  latitude: number;
  longitude: number;
};